import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";

const StepOneNeuf = ({ sendData, isActive, onNext, commonData, handleSave}) => {
    const [formData, setFormData] = useState({
        //CERTIFICATION DE CONFORMITÉ 
        ccv_1: null, // "Véhicule" 0: constructeur 1: representant accrédité
        ccs_1: null, // "Nom et prénom"
        ccs_2_1: null, // "Date de réception par type" JJ
        ccs_2_2: null, // "Date de réception par type" MM
        ccs_2_3: null, // "Date de réception par type" AAAA
        ccs_3: null, // "Sous le n° (K) "

        // VÉHICULE
        veh_0: '0', // Valeur par défaut à "1" pour que les champs soient visibles par défaut
        veh_1: null, // "Marque (D.1)"
        veh_2: null, // "Type, variante, version (D.2)"
        veh_3: null, // "C.N.I.T (D.2.1)"
        veh_5: null, // "Usage" 0: non 1: oui
        // si non à CoC :
        veh_4: null, // "Dénomination commerciale (D.3)"
        veh_6: null, // "N° identification du véhicule (E)"
        veh_7: null, // "Masse en charge max. tech. adm. (F.1)"
        veh_8: null, // "Masse ch. max. adm. dans l'Etat membre (F.2)"
        veh_9: null, // "Masse en charge max. de l'ensemble (F.3)"
        veh_10: null, // "Masse en service (G)"
        veh_11: null, // "Poids à vide national (G.1)"
        veh_12: null, // "Catégorie (J)"
        veh_13: null, // "Genre national (J.1)"
        veh_14: null, // "Carrosserie CE ( J.2)"
        veh_15: null, // "Carr. nationale (J.3)"
        veh_16: null, // "Cylindrée ( P.1) "
        veh_17: null, // "Puiss. nette maxi (P.2)"
        veh_18: null, // "Type de carburant ou source d'énergie (P.3)"
        veh_19: null, // "Puissance administrative nationale (P.6)"
        veh_20: null, // "Rapp. puiss / Masse (motocycles) (Q)"
        veh_21: null, // "Places assises (S.1) "
        veh_22: null, // "Places debout (S.2)"
        veh_23: null, // "Niveau sonore (U.1) "
        veh_24: null, // "Vitesse du moteur (en m-1) (U.2)"
        veh_25: null, // "Co2 (en g/km) (V.7) "
        veh_26: null, // "Classe environnementale (V.9)"

        // NUANCES ET COULEUR
        veh_33: null, // "Nuance" 0: clair 1: foncé
        veh_34: null, // "Couleur dominante " 0: Noir 1: Marron 2: Bleu 3:Rouge 4:Beige 5:Orange 6:Gris 7:Jaune 8:Vert 9:Blanc

        // New fields for the certificate text
        vde_1: null, // "Nom de la société"
        vde_2_1: null, // "Date de vente" JJ
        vde_2_2: null, // "Date de vente" MM
        vde_2_3: null, // "Date de vente" AAAA
        tit_2: null, // "Sexe" 0: masculin 1: féminin
        tit_7: null, // "Département de naissance"
        
        // Nouveaux champs pour le titulaire
        tit_veh_27: null, // "N° d'immatriculation du véhicule (A)"
        tit_veh_29_1: null, // "Date de 1ère immatriculation (B)" JJ
        tit_veh_29_2: null, // "Date de 1ère immatriculation (B)" MM
        tit_veh_29_3: null, // "Date de 1ère immatriculation (B)" AAAA
        tit_veh_28_1: null, // "Date de certificat actuel (I)" JJ
        tit_veh_28_2: null, // "Date de certificat actuel (I)" MM
        tit_veh_28_3: null, // "Date de certificat actuel (I)" AAAA
    });

    useEffect(() => {
        if (commonData?.stepOneData && Object.keys(commonData.stepOneData).length > 0) {
            setFormData(prevState => ({
                ...prevState,
                ...commonData.stepOneData
            }));
            console.log("StepOne mounted", commonData.stepOneData);
        } else if (commonData) {
            const { numero_dossier, statut, vendeur_id } = commonData;
            setFormData(prevState => ({
                ...prevState,
                numero_dossier,
                statut,
                vendeur_id
            }));
        }  console.log("StepOne mounted", commonData.stepOneData);
    }, [commonData?.stepOneData, commonData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Majuscule sauf pour le numéro K
        const newValue = e.target.type === 'text' && name !== 'ccs_3' ? value.toUpperCase() : value;
        setFormData({
            ...formData,
            [name]: newValue
        });
    };

    const handleRadioChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDateFieldChange = (e, fieldPrefix, part) => {
        const { value } = e.target;
        let newValue = value.replace(/[^0-9]/g, '');
        
        if (part === '1') { // Day
            // Only allow 01-31
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 31) newValue = '31';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '2') { // Month
            // Only allow 01-12
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 12) newValue = '12';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '3') { // Year
            // Only allow 4 digit years
            newValue = newValue.slice(0, 4);
            // Ensure year is not in the future
            const currentYear = new Date().getFullYear();
            if (newValue && parseInt(newValue) > currentYear && newValue.length === 4) 
                newValue = currentYear.toString();
        }
        
        setFormData({
            ...formData,
            [`${fieldPrefix}_${part}`]: newValue
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (onNext) onNext();
    };

    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>CERTIFICATION DE CONFORMITÉ PAR LE CONSTRUCTEUR OU LE REPRÉSENTANT ACCRÉDITÉ</h3>
                <div className="radio-group">
                    <label>VÉHICULE:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="ccv_1_constructeur"
                                name="ccv_1"
                                value="0"
                                checked={formData.ccv_1 === '0'}
                                onChange={() => handleRadioChange('ccv_1', '0')}
                                required
                            />
                            <label htmlFor="ccv_1_constructeur">DU CONSTRUCTEUR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="ccv_1_representant"
                                name="ccv_1"
                                value="1"
                                checked={formData.ccv_1 === '1'}
                                onChange={() => handleRadioChange('ccv_1', '1')}
                            />
                            <label htmlFor="ccv_1_representant">DU REPRÉSENTANT ACCRÉDITÉ</label>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="ccs_1">NOM ET PRÉNOM:</label>
                    <input
                        type="text"
                        id="ccs_1"
                        name="ccs_1"
                        value={(formData.ccs_1 === null || formData.ccs_1 === undefined) ? '' : formData.ccs_1}
                        onChange={handleInputChange}
                        maxLength="100"
                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                        title="Veuillez saisir un nom valide (lettres, espaces, tirets et apostrophes seulement)"
                        required
                    />
                </div>

                <div className="form-group">
                    <label>DATE DE RÉCEPTION PAR TYPE:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="ccs_2_1">JOUR</label>
                            <input
                                type="text"
                                id="ccs_2_1"
                                name="ccs_2_1"
                                value={formData.ccs_2_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'ccs_2', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'ccs_2', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="ccs_2_2">MOIS</label>
                            <input
                                type="text"
                                id="ccs_2_2"
                                name="ccs_2_2"
                                value={formData.ccs_2_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'ccs_2', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'ccs_2', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="ccs_2_3">ANNÉE</label>
                            <input
                                type="text"
                                id="ccs_2_3"
                                name="ccs_2_3"
                                value={formData.ccs_2_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'ccs_2', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="ccs_3">SOUS LE N° (K):</label>
                    <input
                        type="text"
                        id="ccs_3"
                        name="ccs_3"
                        value={formData.ccs_3 || ''}
                        onChange={handleInputChange}
                        maxLength="50"
                        pattern="^[A-Za-z0-9\-\*\.\/]+$"
                        title="Veuillez saisir un numéro d'homologation valide (lettres, chiffres et caractères spéciaux - * . /)"
                        required
                    />
                </div>

                <div className="form-group certificate-text">
                    <p>
                        JE SOUSSIGNÉ.E {formData.ccs_1 || '[...]'} CERTIFIE QUE LE VÉHICULE DECRIT CI-CONTRE A FAIT L&apos;OBJET D&apos;UNE RECEPTION PAR TYPE LE {formData.ccs_2_1 ? `${formData.ccs_2_1}/${formData.ccs_2_2}/${formData.ccs_2_3}` : '[...]'} SOUS LE NUMERO (K) {formData.ccs_3 || '[...]'}
                    </p>
                </div>
            </div>

            <div className="section">
                <h3>IDENTIFICATION DU VÉHICULE</h3>
                <div className="radio-group">
                    <label>DISPOSEZ-VOUS D&apos;UN CERTIFICAT DE CONFORMITÉ EUROPÉEN (COC) SOUS FORME ÉLECTRONIQUE?</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="veh_0_oui"
                                name="veh_0"
                                value="1"
                                checked={formData.veh_0 === '1'}
                                onChange={() => handleRadioChange('veh_0', '1')}
                                required
                            />
                            <label htmlFor="veh_0_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_0_non"
                                name="veh_0"
                                value="0"
                                checked={formData.veh_0 === '0'}
                                onChange={() => handleRadioChange('veh_0', '0')}
                            />
                            <label htmlFor="veh_0_non">NON</label>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="tit_veh_27">N° D&apos;IMMATRICULATION DU VÉHICULE (A):</label>
                    <input
                        type="text"
                        id="tit_veh_27"
                        name="tit_veh_27"
                        value={formData.tit_veh_27 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Z]{2}-[0-9]{3}-[A-Z]{2}|[0-9]{3}-[A-Z]{2}-[0-9]{2}"
                        maxLength="9"
                        required
                    />
                    <small>Format: AB123CD ou 123AB45 ou immatriculation étrangère</small>
                </div>

                <div className="form-group">
                    <label>DATE DE 1ÈRE IMMATRICULATION (B):</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="tit_veh_29_1">JOUR</label>
                            <input
                                type="text"
                                id="tit_veh_29_1"
                                name="tit_veh_29_1"
                                value={formData.tit_veh_29_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'tit_veh_29', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'tit_veh_29', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="tit_veh_29_2">MOIS</label>
                            <input
                                type="text"
                                id="tit_veh_29_2"
                                name="tit_veh_29_2"
                                value={formData.tit_veh_29_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'tit_veh_29', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'tit_veh_29', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="tit_veh_29_3">ANNÉE</label>
                            <input
                                type="text"
                                id="tit_veh_29_3"
                                name="tit_veh_29_3"
                                value={formData.tit_veh_29_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'tit_veh_29', '3')}
                                onBlur={(e) => handleDateFieldChange(e, 'tit_veh_29', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="veh_1">MARQUE (D.1):</label>
                    <input
                        type="text"
                        id="veh_1"
                        name="veh_1"
                        value={(formData.veh_1 === null || formData.veh_1 === undefined) ? '' : formData.veh_1}
                        onChange={handleInputChange}
                        maxLength="50"
                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s\-]+$"
                        title="Veuillez saisir une marque valide (lettres, chiffres, espaces et tirets seulement)"
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="veh_2">TYPE, VARIANTE, VERSION (D.2):</label>
                    <input
                        type="text"
                        id="veh_2"
                        name="veh_2"
                        value={(formData.veh_2 === null || formData.veh_2 === undefined) ? '' : formData.veh_2}
                        onChange={handleInputChange}
                        maxLength="50"
                        pattern="^[A-Za-z0-9\s\-\.\/]+$"
                        title="Veuillez saisir un type valide (lettres, chiffres, espaces et caractères spéciaux - . /)"
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="veh_3">C.N.I.T (D.2.1):</label>
                    <input
                        type="text"
                        id="veh_3"
                        name="veh_3"
                        value={(formData.veh_3 === null || formData.veh_3 === undefined) ? '' : formData.veh_3}
                        onChange={handleInputChange}
                        maxLength="15"
                        pattern="^[A-Z0-9]+$"
                        title="Veuillez saisir un CNIT valide (lettres majuscules et chiffres seulement)"
                        required
                    />
                </div>

                <div className="form-group">
                    <label>USAGE:</label>
                    <div className="radio-group-child">
                        <div>
                            <input
                                type="radio"
                                id="veh_5_oui"
                                name="veh_5"
                                value="1"
                                checked={formData.veh_5 === '1'}
                                onChange={() => handleRadioChange('veh_5', '1')}
                                required
                            />
                            <label htmlFor="veh_5_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_5_non"
                                name="veh_5"
                                value="0"
                                checked={formData.veh_5 === '0'}
                                onChange={() => handleRadioChange('veh_5', '0')}
                                required
                            />
                            <label htmlFor="veh_5_non">NON</label>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="veh_6">N° IDENTIFICATION VÉHICULE (E):</label>
                    <input
                        type="text"
                        id="veh_6"
                        name="veh_6"
                        value={(formData.veh_6 === null || formData.veh_6 === undefined) ? '' : formData.veh_6}
                        onChange={handleInputChange}
                        pattern="^[A-HJ-NPR-Z0-9]{17}$"
                        title="Le numéro VIN doit contenir 17 caractères alphanumériques (sans I, O ou Q)"
                        maxLength="17"
                        required
                    />
                </div>
                    <>
                        <div className="form-group">
                            <label htmlFor="veh_4">DÉNOMINATION COMMERCIALE (D.3):</label>
                            <input
                                type="text"
                                id="veh_4"
                                name="veh_4"
                                value={(formData.veh_4 === null || formData.veh_4 === undefined) ? '' : formData.veh_4}
                                onChange={handleInputChange}
                                maxLength={100}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_7">MASSE EN CHARGE MAX. TECH. (F.1):</label>
                            <input
                                type="number"
                                id="veh_7"
                                name="veh_7"
                                value={(formData.veh_7 === null || formData.veh_7 === undefined) ? '' : formData.veh_7}
                                onChange={handleInputChange}
                                min="0"
                                max="100000"
                                step="1"
                                title="Veuillez saisir un poids en kg (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_8">MASSE CH. MAX. ADM. DANS L&apos;ÉTAT MEMBRE (F.2):</label>
                            <input
                                type="number"
                                id="veh_8"
                                name="veh_8"
                                value={(formData.veh_8 === null || formData.veh_8 === undefined) ? '' : formData.veh_8}
                                onChange={handleInputChange}
                                min="0"
                                max="100000"
                                step="1"
                                title="Veuillez saisir un poids en kg (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_9">MASSE EN CHARGE MAX. DE L&apos;ENSEMBLE (F.3):</label>
                            <input
                                type="number"
                                id="veh_9"
                                name="veh_9"
                                value={(formData.veh_9 === null || formData.veh_9 === undefined) ? '' : formData.veh_9}
                                onChange={handleInputChange}
                                min="0"
                                max="100000"
                                step="1"
                                title="Veuillez saisir un poids en kg (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_10">MASSE EN SERVICE (G):</label>
                            <input
                                type="number"
                                id="veh_10"
                                name="veh_10"
                                value={(formData.veh_10 === null || formData.veh_10 === undefined) ? '' : formData.veh_10}
                                onChange={handleInputChange}
                                min="0"
                                max="100000"
                                step="1"
                                title="Veuillez saisir un poids en kg (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_11">POIDS À VIDE NATIONAL (G.1):</label>
                            <input
                                type="number"
                                id="veh_11"
                                name="veh_11"
                                value={(formData.veh_11 === null || formData.veh_11 === undefined) ? '' : formData.veh_11}
                                onChange={handleInputChange}
                                min="0"
                                max="100000"
                                step="1"
                                title="Veuillez saisir un poids en kg (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label>DATE DE CERTIFICAT ACTUEL (I):</label>
                            <div className="date-input-group">
                                <div className="date-field">
                                    <label htmlFor="tit_veh_28_1">JOUR</label>
                                    <input
                                        type="text"
                                        id="tit_veh_28_1"
                                        name="tit_veh_28_1"
                                        value={formData.tit_veh_28_1 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_veh_28', '1')}
                                        onBlur={(e) => handleDateFieldChange(e, 'tit_veh_28', '1')}
                                        placeholder="JJ"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="tit_veh_28_2">MOIS</label>
                                    <input
                                        type="text"
                                        id="tit_veh_28_2"
                                        name="tit_veh_28_2"
                                        value={formData.tit_veh_28_2 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_veh_28', '2')}
                                        onBlur={(e) => handleDateFieldChange(e, 'tit_veh_28', '2')}
                                        placeholder="MM"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="tit_veh_28_3">ANNÉE</label>
                                    <input
                                        type="text"
                                        id="tit_veh_28_3"
                                        name="tit_veh_28_3"
                                        value={formData.tit_veh_28_3 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'tit_veh_28', '3')}
                                        onBlur={(e) => handleDateFieldChange(e, 'tit_veh_28', '3')}
                                        placeholder="AAAA"
                                        maxLength="4"
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_12">CATÉGORIE (J):</label>
                            <input
                                type="text"
                                id="veh_12"
                                name="veh_12"
                                value={(formData.veh_12 === null || formData.veh_12 === undefined) ? '' : formData.veh_12}
                                onChange={handleInputChange}
                                maxLength="10"
                                pattern="^[A-Z0-9]+$"
                                title="Veuillez saisir une catégorie valide (lettres majuscules et chiffres seulement)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_13">GENRE NATIONAL (J.1):</label>
                            <input
                                type="text"
                                id="veh_13"
                                name="veh_13"
                                value={(formData.veh_13 === null || formData.veh_13 === undefined) ? '' : formData.veh_13}
                                onChange={handleInputChange}
                                maxLength="20"
                                pattern="^[A-Z]{2,3}$"
                                title="Veuillez saisir un genre national valide (2 ou 3 lettres majuscules)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_14">CARROSSERIE CE (J.2):</label>
                            <input
                                type="text"
                                id="veh_14"
                                name="veh_14"
                                value={(formData.veh_14 === null || formData.veh_14 === undefined) ? '' : formData.veh_14}
                                onChange={handleInputChange}
                                maxLength="10"
                                pattern="^[A-Z0-9]+$"
                                title="Veuillez saisir une carrosserie CE valide (lettres majuscules et chiffres seulement)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_15">CARR. NATIONALE (J.3):</label>
                            <input
                                type="text"
                                id="veh_15"
                                name="veh_15"
                                value={(formData.veh_15 === null || formData.veh_15 === undefined) ? '' : formData.veh_15}
                                onChange={handleInputChange}
                                maxLength="10"
                                pattern="^[A-Z]{3}$"
                                title="Veuillez saisir une carrosserie nationale valide (3 lettres majuscules)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_16">CYLINDRÉE (P.1):</label>
                            <input
                                type="number"
                                id="veh_16"
                                name="veh_16"
                                value={(formData.veh_16 === null || formData.veh_16 === undefined) ? '' : formData.veh_16}
                                onChange={handleInputChange}
                                min="0"
                                max="10000"
                                step="1"
                                title="Veuillez saisir une cylindrée en cm³ (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_17">PUISS. NETTE MAXI (P.2):</label>
                            <input
                                type="number"
                                id="veh_17"
                                name="veh_17"
                                value={(formData.veh_17 === null || formData.veh_17 === undefined) ? '' : formData.veh_17}
                                onChange={handleInputChange}
                                min="0"
                                max="2000"
                                step="0.1"
                                title="Veuillez saisir une puissance en kW (nombre décimal)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_18">TYPE DE CARBURANT OU SOURCE D&apos;ÉNERGIE (P.3):</label>
                            <input
                                type="text"
                                id="veh_18"
                                name="veh_18"
                                value={(formData.veh_18 === null || formData.veh_18 === undefined) ? '' : formData.veh_18}
                                onChange={handleInputChange}
                                maxLength="2"
                                pattern="^[A-Z0-9]{1,2}$"
                                title="Veuillez saisir un code de carburant valide (1 ou 2 caractères)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_19">PUISSANCE ADMINISTRATIVE NATIONALE (P.6):</label>
                            <input
                                type="number"
                                id="veh_19"
                                name="veh_19"
                                value={(formData.veh_19 === null || formData.veh_19 === undefined) ? '' : formData.veh_19}
                                onChange={handleInputChange}
                                min="1"
                                max="100"
                                step="1"
                                title="Veuillez saisir une puissance administrative (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_20">RAPP. PUISS / MASSE (MOTORCYCLES) (Q):</label>
                            <input
                                type="number"
                                id="veh_20"
                                name="veh_20"
                                value={(formData.veh_20 === null || formData.veh_20 === undefined) ? '' : formData.veh_20}
                                onChange={handleInputChange}
                                min="0"
                                max="2"
                                step="0.001"
                                title="Veuillez saisir un rapport puissance/masse (kW/kg)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_21">PLACES ASSISES (S.1):</label>
                            <input
                                type="number"
                                id="veh_21"
                                name="veh_21"
                                value={(formData.veh_21 === null || formData.veh_21 === undefined) ? '' : formData.veh_21}
                                onChange={handleInputChange}
                                min="1"
                                max="100"
                                step="1"
                                title="Veuillez saisir un nombre de places assises (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_22">PLACES DEBOUT (S.2):</label>
                            <input
                                type="number"
                                id="veh_22"
                                name="veh_22"
                                value={(formData.veh_22 === null || formData.veh_22 === undefined) ? '' : formData.veh_22}
                                onChange={handleInputChange}
                                min="0"
                                max="100"
                                step="1"
                                title="Veuillez saisir un nombre de places debout (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_23">NIVEAU SONORE (U.1):</label>
                            <input
                                type="number"
                                id="veh_23"
                                name="veh_23"
                                value={(formData.veh_23 === null || formData.veh_23 === undefined) ? '' : formData.veh_23}
                                onChange={handleInputChange}
                                min="0"
                                max="150"
                                step="0.1"
                                title="Veuillez saisir un niveau sonore en dB(A) (nombre décimal)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_24">VITESSE DU MOTEUR (EN M-1) (U.2):</label>
                            <input
                                type="number"
                                id="veh_24"
                                name="veh_24"
                                value={(formData.veh_24 === null || formData.veh_24 === undefined) ? '' : formData.veh_24}
                                onChange={handleInputChange}
                                min="0"
                                max="10000"
                                step="1"
                                title="Veuillez saisir une vitesse moteur en min⁻¹ (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_25">CO2 (EN G/KM) (V.7):</label>
                            <input
                                type="number"
                                id="veh_25"
                                name="veh_25"
                                value={(formData.veh_25 === null || formData.veh_25 === undefined) ? '' : formData.veh_25}
                                onChange={handleInputChange}
                                min="0"
                                max="1000"
                                step="1"
                                title="Veuillez saisir une émission de CO2 en g/km (nombre entier)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="veh_26">CLASSE ENVIRONNEMENTALE (V.9):</label>
                            <input
                                type="text"
                                id="veh_26"
                                name="veh_26"
                                value={(formData.veh_26 === null || formData.veh_26 === undefined) ? '' : formData.veh_26}
                                onChange={handleInputChange}
                                maxLength="10"
                                pattern="^(EURO|Euro)\s*[0-9]([abc])?$"
                                title="Veuillez saisir une classe environnementale valide (ex: Euro 6, EURO 5a)"
                                required={formData.veh_0 === '0'}
                            />
                        </div>
                    </>
            </div>

            <div className="section">
                <h3>NUANCE ET COULEUR DOMINANTE</h3>
                <div className="radio-group">
                    <label>NUANCE:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="veh_33_clair"
                                name="veh_33"
                                value="0"
                                checked={formData.veh_33 === '0'}
                                onChange={() => handleRadioChange('veh_33', '0')}
                                required
                            />
                            <label htmlFor="veh_33_clair">CLAIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_33_fonce"
                                name="veh_33"
                                value="1"
                                checked={formData.veh_33 === '1'}
                                onChange={() => handleRadioChange('veh_33', '1')}
                            />
                            <label htmlFor="veh_33_fonce">FONCÉ</label>
                        </div>
                    </div>
                </div>

                <div className="radio-group">
                    <label>COULEUR DOMINANTE:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_noir"
                                name="veh_34"
                                value="0"
                                checked={formData.veh_34 === '0'}
                                onChange={() => handleRadioChange('veh_34', '0')}
                                required
                            />
                            <label htmlFor="veh_34_noir">NOIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_marron"
                                name="veh_34"
                                value="1"
                                checked={formData.veh_34 === '1'}
                                onChange={() => handleRadioChange('veh_34', '1')}
                            />
                            <label htmlFor="veh_34_marron">MARRON</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_bleu"
                                name="veh_34"
                                value="2"
                                checked={formData.veh_34 === '2'}
                                onChange={() => handleRadioChange('veh_34', '2')}
                            />
                            <label htmlFor="veh_34_bleu">BLEU</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_rouge"
                                name="veh_34"
                                value="3"
                                checked={formData.veh_34 === '3'}
                                onChange={() => handleRadioChange('veh_34', '3')}
                            />
                            <label htmlFor="veh_34_rouge">ROUGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_beige"
                                name="veh_34"
                                value="4"
                                checked={formData.veh_34 === '4'}
                                onChange={() => handleRadioChange('veh_34', '4')}
                            />
                            <label htmlFor="veh_34_beige">BEIGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_orange"
                                name="veh_34"
                                value="5"
                                checked={formData.veh_34 === '5'}
                                onChange={() => handleRadioChange('veh_34', '5')}
                            />
                            <label htmlFor="veh_34_orange">ORANGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_gris"
                                name="veh_34"
                                value="6"
                                checked={formData.veh_34 === '6'}
                                onChange={() => handleRadioChange('veh_34', '6')}
                            />
                            <label htmlFor="veh_34_gris">GRIS</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_jaune"
                                name="veh_34"
                                value="7"
                                checked={formData.veh_34 === '7'}
                                onChange={() => handleRadioChange('veh_34', '7')}
                            />
                            <label htmlFor="veh_34_jaune">JAUNE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_vert"
                                name="veh_34"
                                value="8"
                                checked={formData.veh_34 === '8'}
                                onChange={() => handleRadioChange('veh_34', '8')}
                            />
                            <label htmlFor="veh_34_vert">VERT</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="veh_34_blanc"
                                name="veh_34"
                                value="9"
                                checked={formData.veh_34 === '9'}
                                onChange={() => handleRadioChange('veh_34', '9')}
                            />
                            <label htmlFor="veh_34_blanc">BLANC</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="button-container">
                <div></div>
                
                    <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                    <button type="button" className="next-button" onClick={handleSubmit}>SUIVANT</button>
                
            </div>
        </>
    );
};

StepOneNeuf.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepOneNeuf;